export const SERVICES = [
  {
    slug: "consultoria-tecnologica",
    num: "01",
    title: "Consultoría Tecnológica",
    short: "Estrategia tecnológica alineada al negocio: diagnóstico, roadmap y decisiones con criterio.",
    tagline: "Estrategia antes que tecnología.",
    description:
      "Analizamos tu operación, tus sistemas y tus objetivos para definir una hoja de ruta tecnológica realista. No recomendamos tecnología por moda: recomendamos la que resuelve tu problema.",
    points: [
      "Diagnóstico de madurez digital y tecnológica",
      "Hoja de ruta tecnológica priorizada por impacto",
      "Evaluación de arquitectura y deuda técnica",
      "Alineación entre negocio, datos y sistemas",
    ],
    capabilities: ["Assessment", "Roadmap", "Arquitectura", "Gobierno de TI", "Selección de plataformas", "Optimización de costos"],
    flow: ["Negocio", "Diagnóstico", "Estrategia", "Roadmap", "Ejecución"],
  },
  {
    slug: "consultoria-aplicaciones",
    num: "02",
    title: "Consultoría de Aplicaciones",
    short: "Auditamos tus aplicaciones y las convertimos en sistemas modernos, integrados e inteligentes.",
    tagline: "Tus aplicaciones pueden hacer mucho más.",
    description:
      "Analizamos aplicaciones existentes, procesos, arquitectura e integraciones para identificar oportunidades de modernización, automatización y evolución tecnológica.",
    points: [
      "Auditoría funcional y técnica de aplicaciones",
      "Identificación de deuda técnica y riesgos",
      "Oportunidades de modernización y automatización",
      "Diseño de arquitectura objetivo con APIs",
    ],
    capabilities: ["Auditoría", "Modernización", "Arquitectura", "APIs", "Automatización", "Migración"],
    flow: ["Aplicación actual", "Diagnóstico", "Arquitectura", "APIs", "Automatización", "Aplicación inteligente"],
  },
  {
    slug: "software",
    num: "03",
    title: "Desarrollo de Software",
    short: "Software a medida, diseñado alrededor de tu operación y construido para escalar.",
    tagline: "Software diseñado alrededor de tu operación.",
    description:
      "Diseñamos y construimos aplicaciones, plataformas y sistemas internos que se adaptan a la manera en que tu empresa realmente trabaja — no al revés.",
    points: [
      "Aplicaciones y plataformas web a medida",
      "Sistemas internos y herramientas operativas",
      "Productos digitales de principio a fin",
      "Calidad, pruebas y despliegue continuo",
    ],
    capabilities: ["Web Apps", "Plataformas", "Sistemas internos", "UX/UI", "APIs", "DevOps"],
    flow: ["Descubrimiento", "Diseño", "Desarrollo", "Integración", "Evolución"],
  },
  {
    slug: "automatizacion",
    num: "04",
    title: "Automatización Empresarial",
    short: "Eliminamos tareas repetitivas conectando procesos, sistemas y datos.",
    tagline: "Menos tareas repetitivas. Más capacidad para crecer.",
    description:
      "Convertimos procesos manuales en flujos automáticos y trazables: documentos, aprobaciones, notificaciones, reportes e integraciones entre sistemas.",
    points: [
      "Automatización de documentos y solicitudes",
      "Flujos de aprobación y notificaciones",
      "Reportes y tableros automáticos",
      "Orquestación entre sistemas existentes",
    ],
    capabilities: ["Workflows", "RPA", "Documentos", "Aprobaciones", "Reportes", "Integraciones"],
    flow: ["Entrada", "IA", "Automatización", "Resultado"],
  },
  {
    slug: "inteligencia-artificial",
    num: "05",
    title: "Inteligencia Artificial",
    short: "IA aplicada a problemas reales: clasificación, predicción, asistentes y decisiones.",
    tagline: "IA aplicada a problemas reales de negocio.",
    description:
      "Diseñamos soluciones de inteligencia artificial con propósito: modelos y asistentes que se integran a tus procesos y potencian a tus equipos.",
    points: [
      "Asistentes y copilotos internos con IA",
      "Clasificación y extracción inteligente de datos",
      "Analítica predictiva para decisiones",
      "Gobernanza y uso responsable de IA",
    ],
    capabilities: ["LLMs", "Copilotos", "Clasificación", "Predicción", "OCR + IA", "Gobernanza"],
    flow: ["Datos", "Modelo", "Validación", "Integración", "Decisión"],
  },
  {
    slug: "motor-ia",
    num: "06",
    title: "Motor de IA",
    short: "Un motor de inteligencia artificial para analizar procesos y proponer transformación.",
    tagline: "Un motor de inteligencia para tu operación.",
    description:
      "NETSYS AI ENGINE es nuestro enfoque de análisis empresarial con inteligencia artificial: un motor diseñado para convertirse en el cerebro de tus operaciones, conectando procesos, datos y decisiones.",
    points: [
      "Análisis de procesos y detección de oportunidades",
      "Propuestas de arquitectura y automatización",
      "Arquitectura modular lista para APIs de IA",
      "Diseñado para evolucionar con tu empresa",
    ],
    capabilities: ["Análisis", "Diagnóstico", "Recomendación", "Arquitectura", "APIs de IA", "Modular"],
    flow: ["Pregunta", "Análisis", "Diagnóstico", "Propuesta", "Acción"],
  },
  {
    slug: "integracion-apis",
    num: "07",
    title: "Integración de APIs",
    short: "Conectamos tus sistemas para que la información fluya sin fricción.",
    tagline: "Sistemas que hablan entre sí.",
    description:
      "Diseñamos e implementamos integraciones robustas entre aplicaciones, plataformas y servicios, eliminando silos de información y doble digitación.",
    points: [
      "Diseño y exposición de APIs empresariales",
      "Integración entre sistemas legados y modernos",
      "Sincronización de datos en tiempo real",
      "Monitoreo y resiliencia de integraciones",
    ],
    capabilities: ["REST", "Webhooks", "ESB / iPaaS", "Eventos", "Sincronización", "Monitoreo"],
    flow: ["Sistema A", "API", "Orquestación", "Sistema B", "Datos"],
  },
  {
    slug: "transformacion-digital",
    num: "08",
    title: "Transformación Digital",
    short: "Evolución digital con resultados medibles, no proyectos eternos.",
    tagline: "Evolución digital con resultados medibles.",
    description:
      "Acompañamos a tu empresa en un proceso de transformación por etapas: priorizando quick wins, midiendo impacto y construyendo capacidad interna.",
    points: [
      "Estrategia de transformación por etapas",
      "Digitalización de procesos clave",
      "Gestión del cambio y adopción",
      "Medición continua de resultados",
    ],
    capabilities: ["Estrategia", "Digitalización", "Cambio", "Métricas", "Quick wins", "Capacidad interna"],
    flow: ["Diagnóstico", "Priorización", "Ejecución", "Adopción", "Medición"],
  },
  {
    slug: "ciberseguridad",
    num: "09",
    title: "Ciberseguridad",
    short: "Protección diseñada desde la arquitectura, no improvisada después.",
    tagline: "Protección diseñada, no improvisada.",
    description:
      "Evaluamos riesgos, fortalecemos tu infraestructura y aplicaciones, y establecemos prácticas de seguridad que protegen tu operación y tu información.",
    points: [
      "Evaluación de riesgos y vulnerabilidades",
      "Seguridad en aplicaciones y APIs",
      "Protección de infraestructura y datos",
      "Políticas, monitoreo y respuesta",
    ],
    capabilities: ["Assessment", "AppSec", "Hardening", "Monitoreo", "Identidad", "Respuesta"],
    flow: ["Riesgo", "Evaluación", "Protección", "Monitoreo", "Respuesta"],
  },
  {
    slug: "infraestructura-cloud",
    num: "10",
    title: "Infraestructura & Cloud",
    short: "Infraestructura moderna, segura y elástica que escala con tu negocio.",
    tagline: "Infraestructura que escala contigo.",
    description:
      "Diseñamos, migramos y operamos infraestructura en la nube con enfoque en disponibilidad, seguridad y eficiencia de costos.",
    points: [
      "Arquitectura y migración a la nube",
      "Alta disponibilidad y continuidad",
      "Automatización de infraestructura (IaC)",
      "Optimización de costos y rendimiento",
    ],
    capabilities: ["Cloud", "Migración", "IaC", "Contenedores", "Respaldo", "FinOps"],
    flow: ["Evaluación", "Arquitectura", "Migración", "Operación", "Optimización"],
  },
];

export const CASES = [
  {
    title: "Automatización documental",
    problem: "Procesos manuales de revisión y digitación de documentos.",
    solution: "OCR + IA + workflow + API para procesamiento inteligente y trazable.",
  },
  {
    title: "Modernización de aplicaciones",
    problem: "Arquitectura monolítica difícil de mantener y escalar.",
    solution: "APIs + servicios + frontend moderno, evolucionando por etapas.",
  },
  {
    title: "Inteligencia empresarial",
    problem: "Información dispersa en múltiples sistemas.",
    solution: "Integración + datos + dashboards + IA para decidir con claridad.",
  },
];

export const TECH_CAPABILITIES = ["AI", "APIs", "Cloud", "Automation", "Data", "Cybersecurity", "Software", "Integrations"];

export const PROCESS_STEPS = [
  { num: "01", title: "Descubrimos", text: "Comprendemos el problema antes de hablar de tecnología." },
  { num: "02", title: "Analizamos", text: "Evaluamos procesos, tecnología y datos." },
  { num: "03", title: "Diseñamos", text: "Definimos arquitectura y estrategia." },
  { num: "04", title: "Construimos", text: "Desarrollamos e integramos." },
  { num: "05", title: "Automatizamos", text: "Reducimos fricción y tareas repetitivas." },
  { num: "06", title: "Evolucionamos", text: "Medimos y mejoramos continuamente." },
];

export const MANIFESTO = [
  "La tecnología debe simplificar.",
  "La IA debe potenciar a las personas.",
  "La automatización debe eliminar fricción.",
  "El software debe adaptarse al negocio.",
  "Los datos deben convertirse en decisiones.",
  "La innovación debe generar valor.",
];
